module.exports = __webpack_public_path__ + "img/unpublish.50db434c.svg";